import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DireccionUrbana } from '../interfaces/direccionUrbana.interface';
import { Empresa } from '../interfaces/empresa.interface';
import { EmpresaService } from '../services/empresa.service';
import { EmpresaHelperService } from '../services/editar-empresa-helper.service';
import { camposDirecciones } from '../assets/dataErrors';
@Component({
    selector: 'app-dir-urbana',
    templateUrl: './dir-urbana.component.html',
    styleUrls: ['./dir-urbana.component.css'],
})
export class DirUrbanaComponent {
    @Output() direccionUrbanaChanged = new EventEmitter<DireccionUrbana>();

    @Input() mostrarDireccion;
    @Input() encontrado;

    editarDireccion = false;
    empresaForm: FormGroup;
    direccionUrbana: DireccionUrbana;
    municipios = [];
    municipio;
    departamentos = [];
    datosCargados = false;
    direccionActual = '';
    camposDirecciones: any = camposDirecciones;

    constructor(
        private fb: FormBuilder,
        private empresaservise: EmpresaService,
        private empresaHelperService: EmpresaHelperService
    ) {}
    ngOnInit() {
        this.empresaForm = this.fb.group({
            direccion: this.fb.group({
                municipioId: [null, [Validators.required]],
                zona: ['', [Validators.required]],
                complemento: ['', Validators.required],
                viaPrincipalTipo: [null, [Validators.required]],
                viaPrincipalNumero: [null, [Validators.required]],
                viaPrincipalLetra: [null],
                prefijoBis: [null],
                letraPrefijo: [null],
                viaPrincipalCuadrante: [null],
                viaGeneradoraNumero: [null, [Validators.required]],
                viaGeneradoraLetra: [null],
                numeroPlaca: [null, [Validators.required]],
                viaGeneradoraCuadrante: [null],
            }),
        });
    }

    getMunicipio(idDparta?: string) {
        if (idDparta === null) {
            return (this.municipios = []);
        }
        this.empresaservise.getMunicipios(idDparta).subscribe((data) => {
            this.municipios = data;
        });
    }

    mostrarDirForm(empresa: Empresa) {
        const datos = empresa;
        this.empresaForm.get('direccion').patchValue(datos.direccion);
        if (datos.direccion.prefijoBis === 'false') {
            this.empresaForm
                .get('direccion')
                .get('prefijoBis')
                .patchValue(false);
        }
        this.empresaForm
            .get('direccion')
            .get('municipioId')
            .setValue(empresa.direccion.municipio.id);
        this.visualizarDireccion();
    }

    quitarValidador() {
        // Remueve cualquier validación del campo 'complemento'
        if (this.empresaForm.get('direccion').get('zona').value === 'Urbana') {
            this.empresaForm
                .get('direccion')
                .get('complemento')
                .clearValidators();
            this.empresaForm
                .get('direccion')
                .get('complemento')
                .updateValueAndValidity();
        } else {
            this.empresaForm
                .get('direccion')
                .get('complemento')
                .setValidators([Validators.required]);
            this.empresaForm
                .get('direccion')
                .get('complemento')
                .updateValueAndValidity();
        }
    }

    visualizarDireccion() {
        this.direccionActual = this.empresaHelperService.visualizarDireccion(
            this.empresaForm
        );
    }
    public submitFormUr() {
        this.direccionUrbana = this.empresaForm.value.direccion;
        this.quitarValidador();
        if (
            this.direccionUrbana.zona === 'Rural' &&
            this.direccionUrbana.municipioId !== null &&
            this.direccionUrbana.complemento !== ''
        ) {
            this.direccionUrbanaChanged.emit(this.direccionUrbana);
        } else if (this.empresaForm.valid) {
            // Emite los datos al formulario de empresa
            Object.keys(this.direccionUrbana).forEach((key) => {
                if (this.direccionUrbana[key] === 'null') {
                    this.direccionUrbana[key] = null;
                }
            });
            this.direccionUrbanaChanged.emit(this.direccionUrbana);
        } else {
            console.log('falta informacion');
            this.empresaForm.markAllAsTouched();
        }
    }

    public clearForm() {
        this.empresaForm.reset();
    }
    public formActive() {
        this.empresaForm.enable();
    }
    public formDisable() {
        this.empresaForm.disable();
    }

    // Función para verificar si el campo es inválido y tocado
    esInvalidoYtocado(campo: string): boolean {
        const control = this.empresaForm.get(campo);
        return control.invalid && control.touched;
    }
}
